import { NeoModel, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class StaticCurrencyLookup extends ModelBase {

    public staticCurrencyId: number = 0;

    public currencyCode: string = "";

    public currencySymbol: string = "";

    public isDeletedInd: boolean = false;

    public currencyCodeRef1: string = "";
}